var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 55,
    viewBox: "0 0 48 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.90745 34.7795H0V32.175H10.6401V34.7795H6.73268V45.016H3.90745V34.7795Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7695 32.175H17.5948V45.0168H14.7695V32.175Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6367 32.175H32.3224V34.6881H25.4434V37.2933H31.4974V39.8063H25.4434V42.503H32.4146V45.016H22.6367V32.175Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7617 32.175H42.6322C44.2652 32.175 45.5124 32.6151 46.3746 33.4773C47.1082 34.2109 47.4755 35.1831 47.4755 36.4125V36.4489C47.4755 38.5219 46.356 39.8241 44.7238 40.4299L47.8605 45.016H44.558L41.8064 40.9064H39.587V45.016H36.7617V32.175ZM42.4486 38.4119C43.843 38.4119 44.613 37.6961 44.613 36.5961V36.5589C44.613 35.3295 43.7872 34.7245 42.3936 34.7245H39.587V38.4119H42.4486Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 49.1257H13.3909V51.5296H16.1506V49.1257H17.1665V54.9089H16.1506V52.4719H13.3909V54.9089H12.375V49.1257Z",
    fill: "url(#paint0_linear_326_14380)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4531 52.4554V49.1262H22.469V52.4141C22.469 53.4963 23.0142 54.0585 23.9314 54.0585C24.8316 54.0585 25.3856 53.5214 25.3856 52.4554V49.1262H26.4015V52.406C26.4015 54.1329 25.4269 54.9999 23.9144 54.9999C22.4197 54.9999 21.4531 54.1321 21.4531 52.4554Z",
    fill: "url(#paint1_linear_326_14380)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6922 49.1257H33.2861C33.955 49.1257 34.4589 49.2988 34.7978 49.6377C35.0542 49.8941 35.1861 50.216 35.1861 50.5962V50.6124C35.1861 51.3144 34.7897 51.6784 34.3602 51.9008C35.0461 52.1402 35.5088 52.5123 35.5088 53.3058V53.3219C35.5088 54.3548 34.6579 54.908 33.3686 54.908H30.6914V49.1257H30.6922ZM34.171 50.762C34.171 50.2993 33.8159 50.0268 33.1551 50.0268H31.6927V51.5635H33.0807C33.7415 51.5635 34.171 51.3071 34.171 50.779V50.762ZM34.4929 53.199C34.4929 52.7032 34.1047 52.4225 33.3031 52.4225H31.6919V54.0086H33.3775C34.0715 54.0086 34.4929 53.7441 34.4929 53.2152V53.199Z",
    fill: "url(#paint2_linear_326_14380)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9614 19.317C27.5165 19.317 27.0854 19.0792 26.859 18.6611C26.8113 18.5729 26.3842 17.7681 26.1027 16.6843C25.6878 15.0877 25.8075 13.6738 26.4489 12.5949C27.7212 10.4523 29.7238 10.3285 31.3334 10.2282C32.3994 10.1619 33.4072 10.0996 34.2298 9.5205C36.298 8.06542 36.3393 5.69798 36.0084 3.96547C35.1058 4.66591 33.9136 5.12614 32.5038 5.29437C31.9489 5.3607 31.2865 5.35342 30.5844 5.34533C28.6093 5.32349 26.1513 5.29599 25.2154 6.84651C24.8587 7.43777 24.0904 7.62784 23.4991 7.27115C22.9078 6.91446 22.7178 6.14607 23.0745 5.55482C24.7487 2.77892 28.2768 2.81855 30.6127 2.84443C31.2307 2.85171 31.8147 2.85818 32.2086 2.81127C33.1589 2.69804 34.8211 2.29605 35.2716 0.87332C35.4269 0.383979 35.8653 0.0386089 36.3773 0.00302042C36.8893 -0.032568 37.3713 0.248905 37.5921 0.711555C37.6261 0.782731 38.4252 2.47723 38.6218 4.60687C38.8984 7.60601 37.8776 10.0123 35.6687 11.566C34.2678 12.5512 32.727 12.6474 31.4887 12.7243C29.9406 12.8205 29.1714 12.9095 28.5996 13.872C27.9703 14.9308 28.7411 16.8752 29.0606 17.4729C29.3898 18.0803 29.1633 18.8374 28.5559 19.1666C28.3658 19.2685 28.162 19.317 27.9614 19.317Z",
    fill: "url(#paint3_linear_326_14380)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3305 19.3164C20.1291 19.3164 19.9253 19.2679 19.736 19.1651C19.1294 18.8368 18.9038 18.0797 19.2305 17.4731C19.55 16.8753 20.32 14.9309 19.6916 13.873C19.1197 12.9105 18.3505 12.8215 16.8024 12.7253C15.5641 12.6484 14.0233 12.553 12.6224 11.567C10.4135 10.0133 9.39275 7.60699 9.66937 4.60785C9.86591 2.47821 10.665 0.783714 10.699 0.712537C10.9198 0.249079 11.4019 -0.031584 11.9139 0.0040044C12.4259 0.0395928 12.8642 0.384962 13.0195 0.874303C13.4701 2.29703 15.1314 2.69902 16.0826 2.81226C16.4765 2.85917 17.0596 2.8527 17.6784 2.84542C20.0135 2.81953 23.5424 2.7799 25.2167 5.5558C25.5734 6.14705 25.3833 6.91544 24.792 7.27213C24.2008 7.62883 23.4324 7.43875 23.0757 6.8475C22.1399 5.29698 19.6819 5.32448 17.7067 5.34631C17.0054 5.3544 16.3422 5.36168 15.7873 5.29536C14.3792 5.12793 13.187 4.66771 12.2843 3.96807C12.2277 4.26329 12.1816 4.57631 12.1541 4.90065C11.9802 6.95426 12.6216 8.50964 14.0613 9.52148C14.8839 10.0998 15.8909 10.1629 16.9577 10.2292C18.5665 10.3287 20.5691 10.4533 21.8422 12.5958C22.4836 13.6748 22.6025 15.0895 22.1884 16.6853C21.9069 17.7691 21.4799 18.5739 21.4322 18.6621C21.2049 19.0786 20.7746 19.3164 20.3305 19.3164Z",
    fill: "url(#paint4_linear_326_14380)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9657 26.1372C32.8854 26.1372 30.9361 25.2669 29.5554 23.786C28.1739 25.2669 26.2255 26.1372 24.1452 26.1372C22.0649 26.1372 20.1156 25.2669 18.7349 23.786C17.3534 25.2669 15.405 26.1372 13.3247 26.1372C12.6339 26.1372 12.0742 25.5775 12.0742 24.8868C12.0742 24.196 12.6339 23.6363 13.3247 23.6363C15.1251 23.6363 16.7776 22.6512 17.6357 21.0651C17.8541 20.6615 18.2763 20.4099 18.7357 20.4099C19.1951 20.4099 19.6173 20.6615 19.8357 21.0651C20.6939 22.6512 22.3455 23.6363 24.1468 23.6363C25.9472 23.6363 27.5997 22.6512 28.4578 21.0651C28.6762 20.6615 29.0984 20.4099 29.5578 20.4099C30.0173 20.4099 30.4395 20.6615 30.6579 21.0651C31.516 22.6512 33.1676 23.6363 34.9689 23.6363C35.6596 23.6363 36.2194 24.196 36.2194 24.8868C36.2194 25.5775 35.6564 26.1372 34.9657 26.1372Z",
    fill: "url(#paint5_linear_326_14380)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_326_14380",
    x1: 12.2134,
    y1: 52.0177,
    x2: 35.2316,
    y2: 52.0177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.49178e-7,
    stopColor: "#2A8DD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36D9D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_326_14380",
    x1: 12.2117,
    y1: 52.0628,
    x2: 35.2299,
    y2: 52.0628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.49178e-7,
    stopColor: "#2A8DD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36D9D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_326_14380",
    x1: 12.2139,
    y1: 52.0177,
    x2: 35.2321,
    y2: 52.0177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.49178e-7,
    stopColor: "#2A8DD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36D9D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_326_14380",
    x1: 11.6008,
    y1: 24.7016,
    x2: 36.8739,
    y2: 2.52034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.49178e-7,
    stopColor: "#2A8DD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36D9D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_326_14380",
    x1: 6.09203,
    y1: 18.4237,
    x2: 31.3652,
    y2: -3.75751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.49178e-7,
    stopColor: "#2A8DD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36D9D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_326_14380",
    x1: 17.151,
    y1: 31.0249,
    x2: 42.4242,
    y2: 8.84371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.49178e-7,
    stopColor: "#2A8DD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36D9D8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMenu);
export default __webpack_public_path__ + "static/media/logo-menu.2ae0ae067ed0b996492dfd960634064e.svg";
export { ForwardRef as ReactComponent };